import { gql } from '@apollo/client';

export const CREATE_SUPPORT_TICKET = gql`
  mutation createSupportTicket($input: CreateSupportTicketInput!) {
    createSupportTicket(input: $input)
  }
`;
